var exports = {
  "Kk": "InviteEmbed.module__icon___MEdNWW",
  "EU": "InviteEmbed.module__iconFallback___MEdNWW",
  "C1": "InviteEmbed.module__titleRowWithIcon___MEdNWW",
  "gn": "InviteEmbed.module__titleContainer___MEdNWW",
  "Qw": "InviteEmbed.module__titleText___MEdNWW",
  "fH": "InviteEmbed.module__headerInvite___MEdNWW",
  "dT": "InviteEmbed.module__inviteWrapper___MEdNWW",
  "M1": "InviteEmbed.module__stats___MEdNWW",
  "dJ": "InviteEmbed.module__stat___MEdNWW",
  "gW": "InviteEmbed.module__statDot___MEdNWW",
  "rR": "InviteEmbed.module__statDotOnline___MEdNWW",
  "rb": "InviteEmbed.module__statDotMembers___MEdNWW",
  "KA": "InviteEmbed.module__statText___MEdNWW",
};

module.exports = exports;
